import React from "react";
import { APIKey, FormSectionElements, FormSubSections, LOVValues } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { Checkbox } from "primereact/checkbox";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";
import { styled } from "styled-components";
import { spacing } from '../../theme';
import Utils from "../../utilities/Utils";
import { getRootComponent } from "../../utilities/ElementUtils";
import { apiUrl } from "../../config";
import { combineUrl } from "../../utilities/URLUtils";
import SessionStorageService from "../../services/SessionStorageService";
import { setBaseHeaders } from "../../utilities/submitUtils";
import { SpinnerComponent } from "../../commonComponent/SpinnerComponent";
import { getEnvVar } from "../../config/RuntimeConfig";

// const CheckboxContainer = styled.div<{errorbottom}>`
//    margin-bottom: ${(props) => (props.errorbottom==='true' ? '0px' : spacing.spacing7)};
// `; 
const CheckboxContainer = styled.div<{ indents?: string, marginBottom?: string }>`
    margin-bottom:  ${props => {
    const marginBottom = props.marginBottom ? spacing[props.marginBottom] : spacing.spacing1;
    return marginBottom;
  }}; 
    margin-left: ${props => {
    const val = parseInt(props.indents);
    return !isNaN(val) && val > 0 ? props.indents + 'rem' : spacing.spacing0
  }}; 
`;
interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  optionsFieldValue?: Map<string, string>;
  labelControlArray;
  HideOptionalText?,
  requiredField;
  callbackElement;
  isEng: boolean;
  onBusyChange?: (isBusy: boolean) => void;
}

interface State {
  isBusy: boolean;
  isProcessing: boolean;
}
export class MultipleCheckboxComponent extends React.Component<Props, State> {
  debounceTimer: NodeJS.Timeout;


  constructor(props: Props) {
    super(props);
    const field = this.props.field;
    if (field) {
      field.IsDirty = false;
    }
    this.state = {
      isBusy: false,
      isProcessing: false
    };

    FormValidationUtils.runJavascript(field);
    this.debounceTimer = null;
  }

  private getDelimiter = () => getRootComponent(this.props.field)?.ToSanitize ? '|' : '#';

  setSelectedcheckedboxes = (val) => {
    let field = this.props.field;
    if (!field.Visible) return null;
    let newVal = val;
    if (Array.isArray(val)) {
      newVal = val.join(this.getDelimiter());
    }
    field.Value = newVal;

    FormValidationUtils.runJavascript(field);

  }
  componentWillUnmount() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  }
  onCheckedboxesChange = (e) => {
    let field = this.props.field;
    const delimiter = this.getDelimiter();
    if (field.ReadOnly) {
      e?.preventDefault?.();
      e.target.checked = this.props.field.Value?.split(delimiter).includes(e.target.value);
      return;
    }
    let _selectedRecord = []

    if (this.props.field.Value != null) {
      _selectedRecord = [...field.Value.split(delimiter)];
      _selectedRecord = _selectedRecord.filter(p => p != '')
    }

    if (e.target.checked) {
      if (field.Single == 'Y') {
        _selectedRecord = [e.target.value];
      } else {
        _selectedRecord.push(e.target.value);
      }

    } else {
      if (field.Single == 'Y') {
        _selectedRecord = [];
      } else {
        for (let i = 0; i < _selectedRecord.length; i++) {
          const selectedRow = _selectedRecord[i];

          if (selectedRow === e.target.value) {
            _selectedRecord.splice(i, 1);
            break;
          }
        }
      }
    }

    this.setSelectedcheckedboxes(_selectedRecord);

    if (_selectedRecord.length == 0 && this.props.requiredField) {
      field.IsEmpty = true;
      field.Valid = false;
    } else {
      field.IsEmpty = false;
      field.Valid = true;
    }
    field.Touched = true;

    FormValidationUtils.markFieldDirty(field);

    if (field.Script) {
      const customJSFunc = eval(`(${field.Script})`);
      customJSFunc(field);
    }
    if (field.EventScript) {
      const customJSFunc = eval(`(${field.EventScript})`);
      customJSFunc(field, e);
    }

    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.setState({ isProcessing: true }, () => {
      this.debounceTimer = setTimeout(() => {
        try {
          if (field.Script) {

            const customJSFunc = eval(`(${field.Script})`);
            customJSFunc(field);

          }
          // notify parent after debounce
          this.props.callbackElement(getRootComponent(field));
        } catch (err) {
          console.error('callbackElement error', err);
        } finally {
          this.setState({ isProcessing: false });
          this.debounceTimer = null;
        }
      }, 200); // <-- change 200 to whatever delay (ms) you want
    });

    this.props.callbackElement(getRootComponent(field));

  }

  async componentDidMount(): Promise<void> {
    const field = this.props.field;

    if (field.LovAPI) {

      const getUrl = field.LovAPI;
      let response;
      const root = getRootComponent(field);
      if (root.UseProxy == "Y") {
        let transferPayload = {
          url: getUrl,
          httpMethod: 'GET',
          payload: ""
        }

        response = await axios.post(apiUrl() + "/tponTransfer", transferPayload);

      } else {
        // let token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        // const headers = {
        //   'Authorization': `Bearer ${token}`
        // }
        const programContainer = getRootComponent(field);
        //     if(programContainer.AuthRequired=='ps'){
        //   const psToken=SessionStorageService.getPSToken();
        //   if(psToken){
        //     axios.defaults.headers.common['Authorization'] = `Bearer ${psToken}`;
        //   }
        // } else {
        //    const accessToken = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        //     axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        //       console.log("accessToken", accessToken);
        // }

        if (this.props.onBusyChange)
          this.props.onBusyChange(true);
        const fullUrl = combineUrl(root.APIBasePath, getUrl);
        const apiKey: APIKey = (programContainer.ApiKeyKey && programContainer.ApiKeyValue) ? { key: programContainer.ApiKeyKey, value: programContainer.ApiKeyValue } : null;

        const authToken = SessionStorageService.getAuthToken(programContainer.AuthRequired) ?? programContainer.Profile?.token;
        const headers = setBaseHeaders('application/json', authToken, apiKey);

        const configs = {
          ...{ headers },  // Headers
          withCredentials: true
        }
        let url = programContainer.APIBasePath + "/" + field.LovAPI;

        if (field.LovAPI.startsWith("http://") || field.LovAPI.startsWith("https://")) {
          url = field.LovAPI;
        }

        // const response = await axios.get(url,);
        this.setState({ isBusy: true });
        response = await axios.get(fullUrl, configs);
        this.setState({ isBusy: false });
        if (this.props.onBusyChange)
          this.props.onBusyChange(false);
      }
      field.ListOfLOVValues = response.data;
      this.props.callbackElement(root);
    }
  }

  convertToReactElement(content: string): any {
    if (!content) {
      return null;
    }

    const HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();
    return htmlToReactParser.parse(content);
  }

  render() {
    let field = this.props.field;
    const delimiter = this.getDelimiter();
    FormValidationUtils.runJavascript(field);
    if (!field.Visible) return null;
    let editable = this.props.editable;
    let controlArray = [];
    const title = field.richTextChecked && this.props.labelControlArray ? this.props.labelControlArray : (this.props.isEng ? field.ENUTitle: field.FRATitle);
    const requiredLabel = this.props.field.Optional == "N" ? this.props.isEng ? "(required)" : "(obligatoire)" : this.props.HideOptionalText == "Y" ? "" : this.props.isEng ? "(optional)" : "(facultatif)";
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;
    const lovCheckList = this.applyFilter(field);
    const sectionReadOnly = field.parent?.parent?.SectionReadonly === true;
    field.ReadOnly = field.ReadOnly || sectionReadOnly;
    // Group continuation styling - collapse top spacing
    const containerStyle: React.CSSProperties = {};
    if (field.GroupContinuation) {
      containerStyle.marginTop = '0';
      containerStyle.paddingTop = '0';
    }

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id} className={`ontario-form-group${field.GroupContinuation ? ' group-continuation' : ''}`} style={containerStyle}>
          <fieldset className={`ontario-fieldset${field.GroupContinuation ? ' group-continuation' : ''}`} id={`${field.LoadBindName}`} aria-describedby={field.Valid ? undefined : `${field.LoadBindName}-${field.Id}-error`}>
            {!field.NoLabel && <legend className="ontario-fieldset__legend" id={`label_${field.LoadBindName}`} key={'fdLbl_' + field.Id} style={field?.fieldSize ? { fontSize: field?.fieldSize } : undefined}>
              {title}
              {field.showOptionalLabel && <><span className='ontario-label__flag'>{title ? requiredLabel : null}</span>{" "} {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}</>}
            </legend>}
            {hintHtml ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={field.Valid ? undefined : -1} style={field?.fieldHintSize ? { fontSize: field?.fieldHintSize } : undefined} dangerouslySetInnerHTML={{ __html: hintHtml }}></p> : null}  
            {!getRootComponent(field).ErrorBottom && (<LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />)}
            <div key={'div_sub_' + field.Datatype + '_' + field.Id} className="ontario-padding-bottom-8-! ontario-padding-top-0-! " style={{ ...(field.Horizontal == 'Y' && { display: 'flex', width: '100%' }), marginTop: -spacing.spacing5, marginBottom: getRootComponent(field).ErrorBottom ? '4px' : "2%" }}>
              {
                lovCheckList.map((val, index) => {
                  const rawCode = val?.code ?? '';
                  const code = typeof rawCode === 'string' ? rawCode : String(rawCode);
                  const baseId = code.trim() || `option-${index}`;
                  const sanitizedBaseId = baseId
                    .replace(/[^a-zA-Z0-9]/g, '-')
                    .replace(/-+$/, '');
                  const safeIdSuffix = sanitizedBaseId || `option-${index}`;
                  const inputId = `${field.LoadBindName}-${safeIdSuffix}`;
                  const labelId = `${field.LoadBindName}${safeIdSuffix}_label`;
                  return (
                    <CheckboxContainer indents={this.props.field.indents?.toString()} marginBottom={this.props.field.MarginBottom} key={'fdIpt_CheckContainer_' + index}>
                      <div key={'fdIpt_Checkbox_' + this.props.isEng + val.Sequence} title={field.TooltipENU}>
                        <div key={'fdIpt2_Checkbox_' + this.props.isEng + val.Sequence} className="ontario-checkboxes__item ontario-checkboxes__single-option" style={{ ...(getRootComponent(field).ErrorBottom && { marginBottom: field.Horizontal == 'Y' ? '0px' : '1px' }) }}>
                          <input
                            className={field.Valid ? "ontario-checkboxes__input" : "ontario-checkboxes__input ontario-checkboxes__error"}
                            id={inputId}
                            key={'fdIpt_checkboxes_' + safeIdSuffix}
                            name={`${field.LoadBindName}`} type="checkbox"
                            readOnly={field.ReadOnly}
                            checked={this.props.field.Value != null && this.props.field.Value.split(delimiter).includes(code)}
                            onChange={this.onCheckedboxesChange} value={code}
                          />
                          <label
                            key={'fdIpt2_label_' + this.props.isEng + val.Sequence}
                            className="ontario-checkboxes__label"
                            htmlFor={inputId}
                            id={labelId}
                            style={{
                              ...(field.Horizontal == 'Y' ? { padding: "0 1rem 0 0.2rem" } : {}),
                              display: 'inline-flex',
                              flex: '0 0 auto',
                            }}
                          >
                            {!!field.displayAsRichText ? (this.props.isEng ? this.convertToReactElement(val.richText) : this.convertToReactElement(val.richTextFRA)) : (this.props.isEng ? val.description : val.FRADescription)}
                          </label>

                        </div>
                      </div>
                    </CheckboxContainer>
                  )
                })}
            </div>
            {getRootComponent(field).ErrorBottom && (<LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
              />)}
              </fieldset>
        </div>
      );
      controlArray.push(<div>
        <SpinnerComponent isBusy={this.state.isBusy && getEnvVar('IS_RUNTIME') != 'false'} />
      </div>);
    } else {
      const selectedCodes = (field.Value || '').split(delimiter).filter(code => code);
      const selectedDescriptions = lovCheckList
        .filter(opt => selectedCodes.includes(opt.code))
        .map(opt => this.props.isEng ? opt.description : opt.FRADescription)
        .filter(desc => desc);

      controlArray.push(
        <div
          key={'div_' + field.Datatype + '_' + field.Id}
          className="pdf-two-column"
          style={{ marginBottom: '0px' }}
        >
          <div key={'div2_' + field.Datatype + '_' + field.Id}>{this.props.isEng?this.props.field.ENUTitle:this.props.field.FRATitle}</div>
          <div key={'div3_' + field.Datatype + '_' + field.Id}>
            <br />
            {selectedDescriptions.map((desc, idx) => (
              <div key={idx}>{desc}</div>
            ))}
          </div>
        </div>
      );
    }
    return controlArray;
  }

  applyFilter = (field: FormSectionElements): LOVValues[] => {
    const list = field.ListOfLOVValues
    let lst: LOVValues[] = [];
    let fieldValue = '';
    let validValue: boolean = false;
    const delimiter = this.getDelimiter();
    list.forEach(opt => {
      if (!Utils.isNullOrEmpty(opt.FilterField) && !Utils.isNullOrEmpty(opt.FilterValue)
        && this.props.optionsFieldValue && this.props.optionsFieldValue.size > 0 && this.props.optionsFieldValue.has(opt.FilterField)) {
        if (this.props.optionsFieldValue.get(opt.FilterField).split(delimiter).includes(opt.FilterValue)) {
          //if(Utils.equalsOrBothEmpty(field.Value,opt.code)) validValue=true;
          if (field.Value && field.Value.split(delimiter).includes(opt.code)) fieldValue += fieldValue.length > 0 ? (delimiter + opt.code) : opt.code;
          lst.push(opt);
        }
      } else {
        //if(Utils.equalsOrBothEmpty(field.Value,opt.code)) validValue=true;
        if (field.Value && field.Value.split(delimiter).includes(opt.code)) fieldValue += fieldValue.length > 0 ? (delimiter + opt.code) : opt.code;
        lst.push(opt);
      }
    })
    field.Value = fieldValue;
    return lst;
  }
}
